
<template>
  <div>
    <el-table :data="shijuanTable.rows" style="width: 100%" highlight-current-row
      ref="multipleTable" row-key="id" @current-change="handleChange">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="cname" width="350" label="考试标题">
      </el-table-column>
      <el-table-column prop="sjsc" label="考试时长" sortable width="150">
        <template slot-scope="scope">
          {{scope.row.sjsc}}分钟
        </template>
      </el-table-column>
      <el-table-column prop="clevel" label="难度" sortable width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.clevel==1">简单</span>
          <span v-if="scope.row.clevel==2">一般</span>
          <span v-if="scope.row.clevel==3">困难</span>
        </template>
      </el-table-column>
      <el-table-column prop="itype" label="单选题" width="100" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.itype1Amount&&scope.row.itype1Fraction">
            {{scope.row.itype1Amount}} / {{scope.row.itype1Fraction}}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="itype" label="多选题" width="100" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.itype2Amount&&scope.row.itype2Fraction">
            {{scope.row.itype2Amount}} / {{scope.row.itype2Fraction}}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column prop="itype" label="判断题" width="100" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.itype3Amount&&scope.row.itype3Fraction">
            {{scope.row.itype3Amount}} / {{scope.row.itype3Fraction}}
          </span>
          <span v-else>--</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;width: 100%;height: 40px;">
      <el-pagination small layout="prev, pager, next" :total="shijuanTable.total" style="float: right;"
        :hide-on-single-page="true" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="formInline.page">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaomingList',
    props: ['currentUser'],
    data() {
      return {
        shijuanTable: {
          rows: [],
          total: 0
        },
        dialogVisible: false,
        formInline: {
          rows: 10,
          page: 1,
          keyword: '',
          state: 1,
          isgl: 1,
          cid: '',
          kstype: '1'
        },
        selectIdArr: [],
        selectRows: []
      }
    },
    methods: {
      getUserList: function(flag) {
        var $this = this;
        this.$axios.get('/kt/ktPapersSet/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.shijuanTable = data;
          this.openMonted();
        });
      },
      handleChange: function(selection) {
          this.$emit('changeSet', selection);
      },
      openMonted: function() {
        if (this.selectUserIds.length > 0) {
          this.shijuanTable.rows.forEach(row => {
            if (this.selectUserIds.indexOf(row.id) >= 0) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            } else {
              this.$refs.multipleTable.toggleRowSelection(row, false);
            }
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      checkSelectable(row) {
        return this.selectUserIds.indexOf(row.id) == '-1';
      },
      changeYx: function(id, row) {
        var index = this.selectIdArr.indexOf(id);
        // 数据变化且已经被选中   需要修改选中的数据的状态值
        if (this.selectIdArr.indexOf(id) >= 0) {
          this.selectRows[index] = row;
          this.$emit('changeSet', this.selectIdArr, this.selectRows);
        }
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
    },
    created: function() {
      this.$set(this.formInline, 'cid', this.currentUser.orgId)
    },
    mounted: function() {},
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getUserList(1)
        },
        deep: true //true 深度监听
      },
    },

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/ShijuanList.vue